import ObjectCopyService from "external-services/object-copy-service/index";

const NS = 'PlanMementoService';

export default function PlanMementoService($rootScope) {
  "ngInject";

  function Memento(maxLength, maxHeapSize) {
    this.enabled = false; // save/load operation can operate only when no action is running
    this.states = [];
    this.current = null; //current state
    this.maxLength = maxLength; //max quantity of states save
    this.maxHeapSize = maxHeapSize; //max heap size occupied, at least one state is stored if size exceed max
    this.notifyChangedStatus();
  }

  Memento.prototype = {
    save: function (state, overrideLast) {
      //Add a state to the memento is allowed only on repose state
      if (this.isEnable()) {
        //Clean up all saved state after the current one as no Redo action is supported after a new state is edited
        this.states.length = (this.current != null) ? (this.current + 1) : 0;
        //Save requested state by...
        if (overrideLast) {
          //override last one
          this.states[this.states.length - 1] = state;
        } else {
          //add on top
          this.states.push(state);
        }
        //Limit states quantity (remove oldest saved state)
        while (this.exceedLimits()) {
          this.states.splice(0, 1);
        }
        //Update current index to the newly added state
        this.current = this.states.length - 1;
        //Notify memento change
        this.notifyChangedStatus();
      }
    },

    get: function (index) {
      var state = null;
      if (this.isEnable()) {
        index = index || this.current;
        if (index >= 0 && index < this.states.length) {
          state = ObjectCopyService.angularSafeCopy(this.states[index]);
        }
      }
      return state;
    },

    getLast: function () {
      return this.get(this.states.length - 1);
    },

    set: function (state, index) {
      if (this.isEnable() && state) {
        index = index || this.current;
        if (index >= 0 && index < this.states.length) {
          this.state[index] = ObjectCopyService.angularSafeCopy(state);
          return true;
        }
      }
      return false;
    },

    setLast: function (state) {
      return this.set(state, this.states.length - 1);
    },

    undo: function () {
      if (this.canUndo()) {
        this.states[this.states.length - 1].command.atomic = true; //after an undo operation the last state is no more mergeable
        this.current = this.current - 1; //move to previous state
        this.notifyChangedStatus();
        return ObjectCopyService.angularSafeCopy(this.states[this.current]); //return previous state
      } else {
        return null;
      }
    },

    redo: function () {
      if (this.canRedo()) {
        this.states[this.states.length - 1].command.atomic = true; //a redo operation the last state is no more mergeable
        this.current = this.current + 1; //move to previous state
        this.notifyChangedStatus();
        return this.states[this.current]; //return previous state
      } else {
        return null;
      }
    },

    notifyChangedStatus: function () {
      //Notify memento change
      $rootScope.$broadcast('memento-changed', this.getInfo());
    },

    enable: function (enabled) {
      this.enabled = enabled;
      this.notifyChangedStatus();
    },

    isEnable: function () {
      return this.enabled;
    },

    canSave: function () {
      return this.isEnable();
    },

    canUndo: function () {
      if (!this.isEnable()) {
        return 0; //0 is equevalent to false
      } else {
        return Math.max(this.current, 0); //amount of undo actions available
      }
    },

    canRedo: function () {
      if (!this.isEnable()) {
        return 0; //0 is equevalent to false
      } else {
        return Math.max((this.states.length - (this.current + 1)), 0); //amount of redo actions available
      }
    },

    getFullness: function () {
      var length = 0,
        heap = 0;
      if (this.maxLength) {
        length = this.states.length / this.maxLength;
      }
      if (this.maxHeapSize) {
        heap = JSON.stringify(this.states).length / this.maxHeapSize;
      }
      return Math.max(length, heap);
    },

    exceedLimits: function () {
      //Can always store one state at least
      if (this.states.length < 2) {
        return false;
      }
      //Check states quantity limit
      if (this.maxLength && this.states.length > this.maxLength) {
        return true;
      } //Check heap size limit
      if (this.maxHeapSize && JSON.stringify(this.states).length > this.maxHeapSize) {
        return true;
      }
      //Status inside configured limits
      return false;
    },

    getInfo: function () {
      return {
        enabled: this.isEnable(),
        size: this.states.length,
        heap: JSON.stringify(this.states).length,
        full: this.getFullness(),
        current: this.current,
        canUndo: this.canUndo(),
        canRedo: this.canRedo(),
        canSave: this.canSave(),
        debug: false
      };
    }
  };
  /************************************************************************************************************************
   *************************************************************************************************************************
   STATIC ATTRIBUTES AND FUNCTIONS
   *************************************************************************************************************************
   ************************************************************************************************************************/

  return Memento;
}
